import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import './JourneyWidget.scss';
import SceneNav from '../SceneNav';
import HomeNav from '../HomeNav';
import MobileNav from '../MobileNav';
import Animation from '../Animation';
import InfoCard from '../InfoCard';
import { breakpoints, baseFontSize } from '@carbon/layout';
import { _setBreakpoint } from '../../store/actionCreators';

const JourneyWidget = ({ cmsLocale }) => {
  const animRight = useSelector((state) => state.animRight);
  const dispatch = useDispatch();

  useEffect(() => {
    const xlg = Number(breakpoints.xlg.width.replace('rem', '')) * baseFontSize;
    const lg = Number(breakpoints.lg.width.replace('rem', '')) * baseFontSize;
    const md = Number(breakpoints.md.width.replace('rem', '')) * baseFontSize;

    const resize = () => {
      let breakpoint;
      if (window.innerWidth >= xlg) breakpoint = 'xlg';
      if (window.innerWidth < xlg) breakpoint = 'lg';
      if (window.innerWidth < lg) breakpoint = 'tablet';
      if (window.innerWidth < md) breakpoint = 'mobile';
      dispatch(_setBreakpoint(breakpoint));
    };
    resize();
    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="bx--grid bx--no-gutter">
      <div className="bx--row">
        <div className="bx--col">
          <div className="journey-ai-widget-container">
            <div className="journey-ai-widget">
              <SceneNav />
              <InfoCard cmsLocale={cmsLocale} />

              <div
                className={`animation-ui-container slow-02 ${
                  animRight ? 'home-right' : ''
                }`}>
                <HomeNav />
                <Animation />
              </div>

              <MobileNav />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

JourneyWidget.propTypes = {
  cmsLocale: PropTypes.string,
};

export default JourneyWidget;
